// Debe coincidir con el límite que valida el backend (middlewares/validatorManager.js)
export const MAX_COMPROMISO = 2000;

// Estado del compromiso de un elector: sin compromiso, pendiente o cumplido
export const ESTADOS_COMPROMISO = {
  SIN_COMPROMISO: { valor: "sin-compromiso", etiqueta: "Sin compromiso" },
  PENDIENTE: { valor: "pendiente", etiqueta: "Por cumplir", icono: "mdi:close-circle" },
  CUMPLIDO: { valor: "cumplido", etiqueta: "Cumplido", icono: "mdi:check-circle" },
};

export const estadoCompromiso = (elector) => {
  if (!elector?.compromiso) return ESTADOS_COMPROMISO.SIN_COMPROMISO;
  return elector.compromisoCumplido ? ESTADOS_COMPROMISO.CUMPLIDO : ESTADOS_COMPROMISO.PENDIENTE;
};

// Totales de compromisos cumplidos y pendientes de una lista de electores
export const contarCompromisos = (electores = []) =>
  electores.reduce(
    (totales, elector) => {
      const estado = estadoCompromiso(elector);
      if (estado === ESTADOS_COMPROMISO.CUMPLIDO) totales.cumplidos += 1;
      if (estado === ESTADOS_COMPROMISO.PENDIENTE) totales.pendientes += 1;
      return totales;
    },
    { cumplidos: 0, pendientes: 0 },
  );

// Deja solo los electores con el estado indicado (sin estado: la lista completa)
export const filtrarPorCompromiso = (electores = [], valorEstado = null) =>
  valorEstado ? electores.filter((elector) => estadoCompromiso(elector).valor === valorEstado) : electores;
